export const handlePropagation = e => e.stopPropagation()
